import { MenuItem, Select, Stack } from '@mui/material';

import { RHFMultiSelect, RHFSelect, RHFTextField } from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';

// Styles
import Styles from './CreateProviderContent.module.scss';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import {
  // useGetAviatorRoundConfigsQuery,
  useGetRetryConfigsQuery,
} from '@Src/generated.graphql';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useCreateProviderForm } from '@Src/shared/forms/providers/CreateProviderFormContext';

const useDropDown = () => {
  // const { data } = useGetAviatorRoundConfigsQuery();
  const { data: retryConfigs } = useGetRetryConfigsQuery();
  // const gameVersionDropdown = useMemo(
  //   () =>
  //     data?.aviatorRoundConfigs?.map(({ description, id }) => (
  //       <MenuItemEx key={id} value={id} name="Game Versions">
  //         {description}
  //       </MenuItemEx>
  //     )),
  //   [data]
  // );
  const retryConfigDropdown = useMemo(
    () =>
      retryConfigs?.retryConfigs?.map(({ name, _id }) => (
        // @ts-ignore
        <MenuItemEx key={_id} value={_id} name="Retry Configs">
          {name}
        </MenuItemEx>
      )),
    [retryConfigs]
  );
  return {
    // gameVersion: gameVersionDropdown,
    retryConfig: retryConfigDropdown,
  };
};

export const CreateProviderContent = () => {
  const { rgs, handleRgsChange } = useGeneral();
  const { currentUser } = useAuthorization();
  const dropdown = useDropDown();
  const methods = useCreateProviderForm();

  const retryScheduledSendCredit = useWatch({
    control: methods.control,
    name: 'retryScheduledSendCredit',
  });

  const rgsForAdmin = ['EU', 'AS', 'AS1', 'SA'];
  const isSuper = currentUser?.isSuper;
  const userRgsIds = currentUser?.rgsIds || [];

  const options = isSuper ? rgsForAdmin : userRgsIds;
  const isRetryConfigEnabled = retryScheduledSendCredit === 'true';

  return (
    <Stack className={Styles.CreateProviderContent}>
      <Select defaultValue={rgs || 'EU'}>
        {options.map((region) => (
          <MenuItemEx
            key={region}
            name={region}
            value={region}
            // @ts-ignore
            onClick={() => handleRgsChange(region)}
          >
            {region}
          </MenuItemEx>
        ))}
      </Select>
      <AtLocator type="text-field" name="name" key="name">
        <RHFTextField name="name" label="Name" />
      </AtLocator>
      <RHFMultiSelect
        name="games"
        label="games"
        variant="outlined"
        chip
        options={[
          { label: 'Aviator', value: 1 },
          { label: 'Mines', value: 2 },
          { label: 'Rubber Duck', value: 3 },
        ]}
      ></RHFMultiSelect>
      <AtLocator type="text-field" name="apiUrl" key="apiUrl">
        <RHFTextField name="apiUrl" label="Api Url" />
      </AtLocator>
      <RHFSelect label="Status" name="status" variant="outlined">
        <MenuItem value="ACTIVE">Active</MenuItem>
        <MenuItem value="INACTIVE">Inactive</MenuItem>
      </RHFSelect>
      <RHFSelect label="Is Internal" name="isInternal" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Sync Round End" name="syncRoundEnd" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect
        label="Retry Scheduled Send Credit"
        name="retryScheduledSendCredit"
        variant="outlined"
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect
        label="Retry Config"
        name="retryConfigId"
        variant="outlined"
        disabled={!isRetryConfigEnabled}
      >
        {dropdown.retryConfig}
      </RHFSelect>
      <RHFSelect label="Refund On Credit Fail" name="refundOnCreditFail" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect
        label="Filter External Provider Bets"
        name="filterExternalProviderBets"
        variant="outlined"
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <RHFSelect label="Credit On Disconnect" name="creditOnDisconnect" variant="outlined">
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      {/* <RHFSelect label="Game versions" name="configId" variant="outlined">
        {dropdown.gameVersion}
      </RHFSelect> */}
      <RHFSelect label="Integration Type" name="integrationType" variant="outlined">
        <MenuItem value="DIRECT">DIRECT</MenuItem>
        <MenuItem value="REVERSE_BGI">REVERSE_BGI</MenuItem>
      </RHFSelect>
    </Stack>
  );
};
